import React from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * An error shown inside a dialog, where the user is looking.
 *
 * A message set on the page behind an open modal is invisible — that is how a
 * duplicate-email failure and a rejected password both looked like nothing
 * happening at all.
 */
export default function ModalError({ message }) {
  if (!message) return null;
  return (
    <div
      className="alert alert-error"
      role="alert"
      style={{ display: 'flex', alignItems: 'flex-start', gap: 7, margin: '4px 0 14px', fontSize: 13 }}
    >
      <AlertTriangle size={14} strokeWidth={2} style={{ flexShrink: 0, marginTop: 1 }} />
      <span>{message}</span>
    </div>
  );
}
